var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg24 = function Svg24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1.81 13.11a1 1 0 0 1 1.34-.038l.074.07 2.777 2.908.3-.314.075-.07a1.001 1.001 0 0 1 1.372 1.45L6.724 18.19a1 1 0 0 1-1.447 0l-3.5-3.667-.066-.077a1 1 0 0 1 .1-1.336M20.851 5.739a1 1 0 0 1 1.44 1.374l-.067.077-10.5 11a1 1 0 0 1-1.447 0l-3.5-3.667-.066-.077a1 1 0 0 1 1.44-1.374l.073.07 2.777 2.908 9.776-10.24z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.851 5.739a1 1 0 0 1 1.44 1.374l-.067.077-6.063 6.351-.074.07a1 1 0 0 1-1.372-1.45l6.062-6.352z"
  })));
};
export default Svg24;